import { createContext, useState } from "react";
export const Context = createContext({
  error: "",
  setError: (v: string) => {},
});

const ErrorContext = ({ children }: any) => {
  const [error, setError] = useState("");

  return (
    <Context.Provider value={{ error, setError }}>{children}</Context.Provider>
  );
};

export default ErrorContext;
